import React from "react";

const RecordingStatus = () => {
  return (
    <div className=" h-6 w-6 bg-red-700 rounded-full border-2 border-white animate-pulse absolute top-5 right-5 z-20"></div>
  );
};

export default RecordingStatus;
